{
    "quick-Search-FilterForUnderReporting":[
        {
            "label": "Group", "columnname": "groupName", "placeholder": "Group Name",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Event", "columnname": "type", "placeholder": "Event",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "OrderID", "columnname": "orderID", "placeholder": "OrderID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "RouteID", "columnname": "routeID", "placeholder": "RouteID",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "quick-Search-FilterForMissingData":[
        {
            "label": "Group", "columnname": "groupName", "placeholder": "Group Name",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Event", "columnname": "type", "placeholder": "Event",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "OrderID", "columnname": "orderID", "placeholder": "OrderID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "RouteID", "columnname": "routeID", "placeholder": "RouteID",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "ClientCatSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "Client Data Events",
            "db_columnname": "clientDataEvents",
            "datatype": "String",
            "mappingkey": "clientDataEvents",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Client Event Count",
            "db_columnname": "clientEventCount",
            "datatype": "String",
            "mappingkey": "clientEventCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Events",
            "db_columnname": "catEvents",
            "datatype": "String",
            "mappingkey": "catEvents",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Event Count",
            "db_columnname": "catEventCount",
            "datatype": "String",
            "mappingkey": "catEventCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Matched",
            "db_columnname": "eventMatched",
            "datatype": "String",
            "mappingkey": "eventMatched",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Differences",
            "db_columnname": "eventDifferences",
            "datatype": "String",
            "mappingkey": "eventDifferences",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "ClientCatDetailCols": [
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "eventType",
            "datatype": "String",
            "mappingkey": "eventType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Record Count",
            "db_columnname": "recordCount",
            "datatype": "String",
            "mappingkey": "recordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "ClientDataCols": [
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "File_Name",
            "datatype": "String",
            "mappingkey": "File_Name",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Processed",
            "db_columnname": "Processed_Flag",
            "datatype": "String",
            "mappingkey": "Processed_Flag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Record",
            "db_columnname": "Record_Count",
            "datatype": "String",
            "mappingkey": "Record_Count",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Process Record",
            "db_columnname": "Processed_Count",
            "datatype": "String",
            "mappingkey": "Processed_Count",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Rejected Count",
            "db_columnname": "Rej_Record_Count",
            "datatype": "String",
            "mappingkey": "Rej_Record_Count",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Skipped Count",
            "db_columnname": "Skipped_Record_Count",
            "datatype": "String",
            "mappingkey": "Skipped_Record_Count",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Processed Update Time",
            "db_columnname": "Created_Date",
            "datatype": "String",
            "mappingkey": "Created_Date",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ClientData Exceptions",
            "db_columnname": "Exception_Count",
            "datatype": "String",
            "mappingkey": "Exception_Count",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "CATDataGroupSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "IN",
            "db_columnname": "IN",
            "datatype": "String",
            "mappingkey": "IN",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "IN-EXCEPTION",
            "db_columnname": "INEXCEPTION",
            "datatype": "String",
            "mappingkey": "INEXCEPTION",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OUT",
            "db_columnname": "OUT",
            "datatype": "String",
            "mappingkey": "OUT",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Matched",
            "db_columnname": "Matched",
            "datatype": "String",
            "mappingkey": "Matched",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Differences",
            "db_columnname": "Differences",
            "datatype": "String",
            "mappingkey": "Differences",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "CATDataCols": [
        {
            "display": "true",
            "ui_columnname": "Group Name",
            "db_columnname": "groupname",
            "datatype": "String",
            "mappingkey": "groupname",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event",
            "db_columnname": "event",
            "datatype": "String",
            "mappingkey": "event",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "IN",
            "db_columnname": "InCount",
            "datatype": "String",
            "mappingkey": "InCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OUT",
            "db_columnname": "OutCount",
            "datatype": "String",
            "mappingkey": "OutCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Matched",
            "db_columnname": "matched",
            "datatype": "String",
            "mappingkey": "matched",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Differences",
            "db_columnname": "countDifference",
            "datatype": "String",
            "mappingkey": "countDifference",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "CorrectedCATSubmissionCols": [
        {
            "display": "true",
            "ui_columnname": "Group Name",
            "db_columnname": "groupname",
            "datatype": "String",
            "mappingkey": "groupname",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Count",
            "db_columnname": "fileCount",
            "datatype": "String",
            "mappingkey": "fileCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DATA Status",
            "db_columnname": "processStatus",
            "datatype": "String",
            "mappingkey": "processStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Data Count",
            "db_columnname": "recordCount",
            "datatype": "String",
            "mappingkey": "recordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Processed Update Time",
            "db_columnname": "fileModified",
            "datatype": "String",
            "mappingkey": "fileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Exception Count",
            "db_columnname": "exceptionCount",
            "datatype": "String",
            "mappingkey": "exceptionCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "SubmittedCATSubmissionCols": [
        {
            "display": "true",
            "ui_columnname": "Group Name",
            "db_columnname": "groupname",
            "datatype": "String",
            "mappingkey": "groupname",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        } ,
        {
            "display": "false",
            "ui_columnname": "File Count",
            "db_columnname": "fileCount",
            "datatype": "String",
            "mappingkey": "fileCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Repair File",
            "db_columnname": "repairFile",
            "datatype": "String",
            "mappingkey": "repairFile",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DATA Status",
            "db_columnname": "processStatus",
            "datatype": "String",
            "mappingkey": "processStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DATA Count",
            "db_columnname": "recordCount",
            "datatype": "String",
            "mappingkey": "recordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Submitted UpdateTime",
            "db_columnname": "fileModified",
            "datatype": "String",
            "mappingkey": "fileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "FINRA_ACK#",
            "db_columnname": "finraRecordCount",
            "datatype": "String",
            "mappingkey": "finraRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FINRA_ACK_UpdateTime",
            "db_columnname": "finraFileModified",
            "datatype": "String",
            "mappingkey": "finraFileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "INGESTION#",
            "db_columnname": "ingestionRecordCount",
            "datatype": "String",
            "mappingkey": "ingestionRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "INGESTION_UpdateTime",
            "db_columnname": "ingestionFileModified",
            "datatype": "String",
            "mappingkey": "ingestionFileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "INTEGRITY#",
            "db_columnname": "integrityRecordCount",
            "datatype": "String",
            "mappingkey": "integrityRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "INTEGRITY_UpdateTime",
            "db_columnname": "integrityFileModified",
            "datatype": "String",
            "mappingkey": "integrityFileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LINKAGE#",
            "db_columnname": "linkingRecordCount",
            "datatype": "String",
            "mappingkey": "linkingRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LINKAGE_UpdateTime",
            "db_columnname": "linkingFileModified",
            "datatype": "String",
            "mappingkey": "linkingFileModified",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Exception Count",
            "db_columnname": "exceptionCount",
            "datatype": "String",
            "mappingkey": "exceptionCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "CATMonthlyFinraSubmissionSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BAU File",
            "db_columnname": "bauFileCount",
            "datatype": "String",
            "mappingkey": "bauFileCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BAU Record",
            "db_columnname": "bauRecordCount",
            "datatype": "String",
            "mappingkey": "bauRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Repair File",
            "db_columnname": "repairFileCount",
            "datatype": "String",
            "mappingkey": "repairFileCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Repair Record",
            "db_columnname": "repairRecordCount",
            "datatype": "String",
            "mappingkey": "repairRecordCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "CATMonthlyFinraRejectionSummaryCols": [
        {
            "display": "true",
            "ui_columnname": "Warning",
            "db_columnname": "warningCount",
            "datatype": "String",
            "mappingkey": "warningCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ingestion",
            "db_columnname": "ingestionCount",
            "datatype": "String",
            "mappingkey": "ingestionCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Intra-Firm",
            "db_columnname": "intrafirmCount",
            "datatype": "String",
            "mappingkey": "intrafirmCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Inter-Firm",
            "db_columnname": "interfirmCount",
            "datatype": "String",
            "mappingkey": "interfirmCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Total",
            "db_columnname": "totalExceptionCount",
            "datatype": "String",
            "mappingkey": "totalExceptionCount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "MissingClientRecordsCols":[
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "ReportDate",
            "datatype": "String",
            "mappingkey": "ReportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Group",
            "db_columnname": "groupName",
            "datatype": "String",
            "mappingkey": "groupName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "EventTimeStamp",
            "db_columnname": "EventDateTime",
            "datatype": "String",
            "mappingkey": "EventDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RouteID",
            "db_columnname": "routeID",
            "datatype": "String",
            "mappingkey": "routeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "Symbol",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ],
    "MissingCATRecordsCols":[
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "ReportDate",
            "datatype": "String",
            "mappingkey": "ReportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Group",
            "db_columnname": "groupName",
            "datatype": "String",
            "mappingkey": "groupName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "EventTimeStamp",
            "db_columnname": "EventDateTime",
            "datatype": "String",
            "mappingkey": "EventDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RouteID",
            "db_columnname": "routeID",
            "datatype": "String",
            "mappingkey": "routeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "Symbol",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ]
}